'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var DefaultTheme = {};

exports.__exports = DefaultTheme;
